export const content = [
    {
      icon: 'dashicons:awards',
      label: 'Qualidade',
    },
    {
      icon: 'flowbite:shield-check-solid',
      label: 'Garantia de 2 anos',
    },
    {
      icon: 'material-symbols:factory',
      label: 'Fabricação Própria',
    },
    {
      icon: 'mdi:truck-fast',
      label: 'Entrega em todo o Brasil',
    },
  ];